import { home } from "../../modules";
import { cancro } from "../../modules";
import { info } from "../../modules";
import { medidas } from "../../modules";
import { login } from "../../modules";
import { videos } from "../../modules";
import { monitoring } from "../../modules";
import { fotos } from "../../modules";
import { arquivos } from "../../modules";
import { imagem } from "../../modules";

export default [
  home.router,
  cancro.router,
  info.router,
  medidas.router,
  login.router,
  videos.router,
  monitoring.router,
  fotos.router,
  arquivos.router,
  imagem.router
];
